<template>
  <div>
    <fixed-header title="Account Type Attributes Management" hideNewOfferBtn />
    <div class="animated fadeIn BillPayments--BillPayments-list">
      <div class="card">
        <div class="card-body d-flex flex-column">
          <h3>Create Account Type Attribute</h3>
          <span class="mb-2">Create new attribute here</span>
          <b-form @submit="onCreateAttribute">
            <b-form-group class="required" label="Name">
              <b-form-input v-model="newAttribute" type="text" size="sm"></b-form-input>
            </b-form-group>
            <b-form-group class="required" label="Account Type">
              <b-form-checkbox v-for="type in sortedAccountTypes" v-model="selectedAcctTypeAttributes" :key="type.id"
                :value="type.id" name="flavour-3a" inline>{{ type.name }}</b-form-checkbox>
            </b-form-group>
            <b-button :disabled="isSaving || !newAttribute || selectedAcctTypeAttributes.length == 0"
                type="submit" variant="primary" class="btn-sm mt-2"><i v-show="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Create Attribute
              </b-button>
          </b-form>
          <hr/>
          <h3>Manage Account Type Attributes</h3>
          <span class="mb-2">Select an account type to manage an attribute</span>
          <b-form @submit="onSubmit">
            <b-form-group class="required" label="Account Type">
              <b-form-select v-model="selectedAcctTypeManage" @change="onAccountTypeChange">
                <option :value="null"></option>
                <option v-for="(selectOption, indexOpt) in sortedAccountTypes" :key="indexOpt" :value="selectOption.id">
                  {{ selectOption.name }}</option>
              </b-form-select>
            </b-form-group>
              <b-form-group class="required" label="Attributes">
                <b-form-checkbox v-for="type in attributes" v-model="updatedAccountTypeAttrib" :key="type.id"
                  :value="type.id" name="flavour-3a" inline>{{ type.name }}</b-form-checkbox>
              </b-form-group>
              <b-button :disabled="isSaving || !selectedAcctTypeManage || updatedAccountTypeAttrib.length == 0"
                  type="submit" variant="primary" class="btn-sm mt-2"><i v-show="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Save Attribute
                </b-button>
          </b-form>
          <hr/>
          <h3>Delete Attribute</h3>
          <b-form @submit="onDeleteAttributes">
            <b-form-group class="required" label="Attribute">
              <b-form-select v-model="attributeForDelete">
                <option :value="null"></option>
                <option v-for="(selectOption, indexOpt) in attributes" :key="indexOpt" :value="selectOption.id">
                  {{ selectOption.name }}</option>
              </b-form-select>
            </b-form-group>
             <b-button :disabled="isDeleting"
                  type="submit" variant="danger" class="btn-sm mt-2"><i v-show="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Delete Attribute
                </b-button>  
          </b-form>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import FixedHeader from '@/shared/components/FixedHeader/indexNew';
  import { mapActions, mapGetters, mapState } from 'vuex';

  export default {
    components: {
      FixedHeader
    },
    data() {
      return {
        isSaving:false,
        newAttribute: null,
        selectedAcctTypeAttributes: [],
        isSavingAttributes: false,
        updatedAccountTypeAttrib: [],
        selectedAcctTypeManage: null,
        attributeForDelete: null,
        isDeleting: false
      };
    },
    metaInfo: () => ({
      title: 'Account Type Attribute Management',
    }),
    computed: {
      ...mapGetters('accountTypes', ['sortedAccountTypes']),
      ...mapState('lookup', ['accountTypeAttributes', 'attributes'])
    },
    methods: {
      ...mapActions('lookup', ['getLookupValueById', 'postLookupValueById', 'getAccountTypeAttributes', 'getAttributes']),
      ...mapActions('companies', ['createAccountTypeAttribute', 'manageAccountTypeAttributes', 'deleteAttribute']),
      async onSubmit(evt) {
        try {
          this.isSaving = true;
          await this.manageAccountTypeAttributes({accountTypeId: this.selectedAcctTypeManage, attributeIds: this.updatedAccountTypeAttrib })
            .then(()=> { this.$snotify.success('Successfully saved changes.') });

          this.isSaving = false;
        }catch (e) {
          this.isSaving = false;
        }
        
      },
      async onCreateAttribute() {
        try {
          this.isSavingAttributes = true;
          let data = await this.postLookupValueById({
            id: 0,
            resource: 'Attributes',
            lookupTableId: 65,
            name: this.newAttribute,
            "active": true
          });

          if (data.id > 0 && this.selectedAcctTypeAttributes.length > 0) {
            for (let i = 0; i < this.selectedAcctTypeAttributes.length; i++) {
              await this.createAccountTypeAttribute({ accountTypeId: this.selectedAcctTypeAttributes[i], attributeId: data.id });
            }
            await this.getAccountTypeAttributes();
          }

          if (this.selectedAcctTypeAttributes.include(this.selectedAcctTypeManage))
            this.onAccountTypeChange();

          this.selectedAcctTypeAttributes = [];
          this.newAttribute = null;
          this.isSavingAttributes = false;
        } catch (e) {
          this.isSaving = false;
        }
      },
      onAccountTypeChange() {
        if (this.selectedAcctTypeManage) {
          this.updatedAccountTypeAttrib = this.accountTypeAttributes.filter(x => x.accountTypeId == this.selectedAcctTypeManage).map(x => x.attributeId);
        } else {
          this.updatedAccountTypeAttrib = [];
        }
      },
      async onDeleteAttributes(row) {
        const deleteConfirmed = await this.openConfirmBox({});
        if (deleteConfirmed) {
          this.isDeleting = true;
          await this.deleteAttribute(this.attributeForDelete);
          this.isDeleting = false;
          //Get the data
          this.getAccountTypeAttributes();
          this.getAttributes();

          if (this.selectedAcctTypeAttributes.include(this.selectedAcctTypeManage))
            this.onAccountTypeChange();
        }
      }
    }
  };
</script>

